import { useQuery } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import * as Schema from 'src/types/graphql';

export const useGetProfileInsights = () => {
  const { language, zone } = useAppConfig();
  const timezone =
    // eslint-disable-next-line new-cap
    Intl.DateTimeFormat().resolvedOptions().timeZone || 'Australia/Melbourne';
  const { data, loading, error } = useQuery(Schema.GetProfileInsightsDocument, {
    variables: { zone, languageCode: language, timezone },
  });

  const viewCount = data?.viewer?.profileInsights?.viewCount;

  return {
    // Only show profile insights if viewCount is greater than 0. This guard is necessary until we can handle non-zero searchImpressions.
    showProfileInsights: (viewCount && viewCount > 0) || false,
    profileInsights: data?.viewer?.profileInsights || null,
    loading,
    error,
  };
};
